import { render, staticRenderFns } from "./homeLetter.vue?vue&type=template&id=679603de"
import script from "./homeLetter.vue?vue&type=script&lang=js"
export * from "./homeLetter.vue?vue&type=script&lang=js"
import style0 from "./homeLetter.vue?vue&type=style&index=0&id=679603de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports